var TwitterUpload = {
	popUpBlock : "",
	uploadImage : function(data){
		// console.log("img is ===> ",event);
		var image = data;
		// This needs to be intergated in the final code.
		$.ajax ({
			url : "php/twitter/saveImage.php",
			type : 'POST',
			data : {
				imgData : image
			},
			
			beforeSend: function(){
				// console.log('start', imgData);
			},

			success: function( result ) {
				console.log('result', result);
				if(result.success){
					console.log("success");
					TwitterUpload.img = result.image;
					TwitterUpload.postToTwitter(TwitterUpload.img);

				} else{
					app.dispatcher.dispatch( EVENTS.SHARE_IMAGE_FB_DONE, "fail" );

					//if( TwitterUpload.popUpBlock){
					//	$(dom.share.status_copy).html( localisation.site.messages.popUpBlock );
					//}else{
					//	$(dom.share.status_copy).html( localisation.site.messages.uploading_error );
					//}
				}
			},

			error : function(e){
				app.dispatcher.dispatch( EVENTS.SHARE_IMAGE_FB_DONE, "fail" );
				//if( TwitterUpload.popUpBlock){
				//	$(dom.share.status_copy).html( localisation.site.messages.popUpBlock );
				//}else{
				//	$(dom.share.status_copy).html( localisation.site.messages.uploading_error );
				//}
			},
			
			fail : function( fail ){
				app.dispatcher.dispatch( EVENTS.SHARE_IMAGE_FB_DONE, "fail" );
				//if( TwitterUpload.popUpBlock){
				//	$(dom.share.status_copy).html( localisation.site.messages.popUpBlock );
				//}else{
				//	$(dom.share.status_copy).html( localisation.site.messages.uploading_error );
				//}
				
				console.log('Saving to server failed', fail);
			}
		});
	},

	postToTwitter:function(image){
		var newString = encodeURI( localisation.social.twitter.message );
		console.log("Post to Twitter", image, newString );
		// This needs to be intergated in the final code.
		var open = window.open( 'php/twitter/start.php?img=' + image + '&txt=' + newString,'_blank');
		if (open === null || typeof(open)==='undefined'){
			TwitterUpload.popUpBlock =  true;
		
			app.dispatcher.dispatch( EVENTS.SHARE_IMAGE_FB_DONE, "blocked" );
		}else{
			TwitterUpload.popUpBlock =  false;
			$(dom.share.status_copy).html( localisation.site.messages.uploading_complete );
			app.dispatcher.dispatch( EVENTS.SHARE_IMAGE_FB_DONE, "success" );

	
		}
			
			//alert();
		
	}
};